import { handleActions } from 'redux-actions'
import { doSignUpFail, doSignUpSuccess } from './SignUpActions'

class State {
  lastUpdate: number | null = null
}

export const signUp = handleActions<State, any>(
  {
    [String(doSignUpSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(doSignUpFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
  },
  new State(),
)

export { State as SignUpState }
